import { render, staticRenderFns } from "./AuthDialog.vue?vue&type=template&id=8cf8b936&scoped=true"
import script from "./AuthDialog.vue?vue&type=script&lang=js"
export * from "./AuthDialog.vue?vue&type=script&lang=js"
import style0 from "./AuthDialog.vue?vue&type=style&index=0&id=8cf8b936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf8b936",
  null
  
)

export default component.exports